// extracted by mini-css-extract-plugin
export default {"container":"UploadStudentUserResult_container__ZVAnP","description":"UploadStudentUserResult_description__ET+tZ","btn":"UploadStudentUserResult_btn__KyC2-"};